import { useRootLoaders } from 'src/storage'
import { Loader } from 'src/ui/widgets'

export const LoaderRoot = () => {
  const { someRootPending } = useRootLoaders()

  return someRootPending ? <Loader overlay /> : <></>
}
